import { render } from "./ModalDocumento.vue?vue&type=template&id=075bcfe7&scoped=true&ts=true"
import script from "./ModalDocumento.vue?vue&type=script&lang=ts"
export * from "./ModalDocumento.vue?vue&type=script&lang=ts"

import "./ModalDocumento.vue?vue&type=style&index=0&id=075bcfe7&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\4\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075bcfe7"]])

export default __exports__